/**
 * Site-wide subtle noise + grain overlay for a cinematic, non-flat dark theme.
 * Mounted once at the app root; sits above content but is pointer-events-none
 * and mix-blend-overlay so it never interferes with UI.
 */
export function NoiseOverlay() {
  return (
    <>
      <div
        aria-hidden="true"
        className="fixed inset-0 pointer-events-none z-[60] opacity-[0.04] mix-blend-overlay"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/%3E%3CfeColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
          backgroundSize: "200px 200px",
        }}
        data-testid="noise-overlay"
      />
      {/* Ambient lime glow anchored top-right — decorative only */}
      <div
        aria-hidden="true"
        className="fixed top-0 right-0 w-[600px] h-[600px] pointer-events-none rounded-full blur-[180px] opacity-40 z-0"
        style={{
          background:
            "radial-gradient(circle, rgba(213,255,63,0.06) 0%, rgba(213,255,63,0) 70%)",
        }}
      />
    </>
  );
}
